// extracted by mini-css-extract-plugin
module.exports = {"root":"auth_root__kGzEk","container":"auth_container__XOq-6","linkButton":"auth_linkButton__2tXYR","formInputError":"auth_formInputError__23WA9"};